import { useSearchParams } from 'react-router-dom';
import useMetaProducts from './useMetaProducts';

const useMetaProduct = () => {
    const [params] = useSearchParams();
    const bicycleId = params.get('sparePartParentId');

    const { products, loading, error } = useMetaProducts();

    if (error) {
        throw error;
    }

    const product = products.find(({ id }) => id === bicycleId);

    return { product, loading };
};

export default useMetaProduct;
